<template>
    <div v-show="visible">
        <el-dialog title="查看家属" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="600px">      
            <div class="container"> 
                <div style="height:80px; margin:5px 16px 0 0px;">
                    <div style="display: block; height:40px;">
                        <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                    </div>
                </div>
                
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    border
                    default-expand-all
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"  :selectable="selectable"></el-table-column>
                    <el-table-column prop="" label="头像" fixed width="70px" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.faceImage != null && scope.row.faceImage != ''">
                                <!-- <img :src="scope.row.faceImage" width="50" height="50"/> -->
                                <el-popover
                                    placement="right"
                                    title=""
                                    trigger="hover">
                                    <img :src="scope.row.faceImage"
                                        style="max-height:250px; max-width:330px"/>
                                    <img slot="reference" :src="scope.row.faceImage" :alt="scope.row.faceImage" style="max-height: 50px;max-width: 130px">
                                </el-popover>
                            </div>
                            <div v-else>
                                未上传
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="称呼" width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="showData(scope.row)">{{scope.row.title}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="identityCard" label="身份证" width="180px">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button style="color: red" @click.native.prevent="del(scope.row)"
                                type="text"
                                size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visible=false">关 闭</el-button>
            </span>  
        </el-dialog>
        
        <!--详情 -->
        <div v-if="familyDetailsVisible">
            <familyDetails ref="familyDetails"></familyDetails>
        </div>
        <!--新增 -->
        <div v-if="addFamillyVisible">
            <addFamilly ref="addFamilly"></addFamilly>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import familyDetails from './FamilyDetails.vue';
    import addFamilly from './AddFamilly.vue';

    export default {
        data(){
            return{
                visible: false,
                familyDetailsVisible:false,
                addFamillyVisible:false,
                data:[],
                form:{
                    id: "",
                    userId: ""
                }
            }
        },
        created:function () {
        },
        components: {
            familyDetails,addFamilly
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            init(data){
                this.visible=true;
                this.getData(data);
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            getData(userId){
                this.form.userId=userId;
                let url  = this.familyUrl;
                let data = {
                    userId: userId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.familys;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.familyDelUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData(this.form.userId);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            showData(row){
                // 触发详情界面
                this.familyDetailsVisible = true;
                this.$nextTick(() => {
                    this.$refs['familyDetails'].init(row);
                })
            },
            setAdd(){
                // 新增界面
                this.addFamillyVisible = true;
                this.$nextTick(() => {
                    this.$refs['addFamilly'].init(this.form.userId);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/sys/user/Family.vue